import React from 'react';

import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReactHookFormIntlNumberInput } from 'common/components/form/bootstrap';
import { getMinMaxGroupTilt } from 'common/utils/helpers/systemsValues';

const TabGroups = ({ control }) => {
    const { t } = useTranslation();
    const [system_uid] = useWatch({
        control,
        name: ['system_uid'],
    });

    const [minTilt, maxTilt] = getMinMaxGroupTilt(system_uid);

    const disabledTilt = minTilt === maxTilt || maxTilt === 0;

    return (
        <ReactHookFormIntlNumberInput
            append="°"
            control={control}
            disabled={disabledTilt}
            fullWidth
            label={t('Tilt')}
            max="90"
            min="0"
            name="tilt"
            placeholder={t('Tilt')}
        />
    );
};

TabGroups.propTypes = { control: PropTypes.object };

export default TabGroups;
